import useStyles from "../../assets/styles/styles";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
    Box,
    Typography,
    CircularProgress
} from "@material-ui/core";
import MenuProfile from "../Menu/MenuProfile";
import CardCommunication from "../Menu/CardCommunication";
import MedicalSection from "./MedicalSection";
import NotFound from "../HomeLogged/NotFound";
import { getMedicalAgenda } from "../../redux/actions/appointmentsActions";
import { format } from "date-fns";
import HeaderCard from "../Billing/Movements/HeaderCard";
import { es } from 'date-fns/locale';
import LocationCityIcon from "@material-ui/icons/LocationCity";
import HomeCardDetailPatient from "../Billing/Movements/HomeCardDetailPatient";



const userCode = parseInt(window.localStorage.getItem("numeroPersona"));

const MedicalProfile = () => {
    const classes = useStyles();
    const dispatch = useDispatch();
    const communicated = useSelector((state) => state.communicatedReducer.communication);
    const date = new Date();
    const modelAgendaMedicalReducer = useSelector(state => state.appointmentsReducer);
    const [modelAgendaMedical] = useState(modelAgendaMedicalReducer?.medicalAgenda);
    const [totalTurns, setTotalTurns] = useState(0);
    const [assignedTurns, setAssignedTurns] = useState(0);
    const [closestTurn, setClosestTurn] = useState(null);
    const [lastTurnOfDay, setLastTurnOfDay] = useState(null);



    useEffect(() => {
        const paramAll = {
            fechaDesde: date?.toISOString()?.split('T')[0],
            fechaHasta: format(date?.setMonth(date?.getMonth() + 1), 'yyyy-MM-dd'),
            numeroPersona: userCode,
            medicoCodigo: modelAgendaMedical?.medicoCodigo ? modelAgendaMedical.medicoCodigo.toString() : undefined,
            parametroAgenda: "TODOS",
        };


        dispatch(getMedicalAgenda(paramAll));
    }, []);



    useEffect(() => {
        if (modelAgendaMedicalReducer?.medicalAgenda?.agenda?.length > 0) {
            const dateAgendaMedical = modelAgendaMedicalReducer?.medicalAgenda?.agenda?.filter(turno => {
                return new Date(turno?.turnoFechHora) > date;
            });

            if (dateAgendaMedical.length > 0) {
                const closest = dateAgendaMedical.reduce((prev, current) => {
                    return new Date(prev?.turnoFechHora) < new Date(current?.turnoFechHora) ? prev : current;
                });
                setClosestTurn(closest);

                const lastTurn = dateAgendaMedical.filter(turno => {
                    return new Date(turno?.turnoFechHora).toDateString() === new Date(closest?.turnoFechHora).toDateString();
                }).reduce((prev, current) => {
                    return new Date(prev?.turnoFechHora) > new Date(current?.turnoFechHora) ? prev : current;
                });
                setLastTurnOfDay(lastTurn);

                const dayShifts = dateAgendaMedical.filter(turno => {
                    return new Date(turno?.turnoFechHora).toDateString() === new Date(closest?.turnoFechHora).toDateString();
                });

                const totalTurns = dayShifts.length;
                const assignedTurns = dayShifts.filter(turno => turno?.estadoTurno?.toUpperCase().trim() === "ASIGNADO").length;
                setTotalTurns(totalTurns);
                setAssignedTurns(assignedTurns);
            }
        }
    }, [modelAgendaMedicalReducer, date]);


    useEffect(() => {
        localStorage.removeItem('handleCalendarClick');
        localStorage.removeItem("selectedCalendarDay");
        localStorage.removeItem("calendarFilters");
    }, []);


    const CenteredCircularProgress = () => {
        return (
            <div className={`${classes.boxPointsDrawer} ${classes.centeredBox} ${classes.circularProgress}`}>
                <CircularProgress />
            </div>
        );
    }

    return (
        <>
            <MenuProfile />
            <Box className={classes.boxHeaderBtnMedicalProfileHome} >
                <Typography className={`${classes.greetingHomeMedical}`} >
                    ¡Bienvenido Dr. / Dra. {window?.localStorage?.getItem("userName")?.replace(/_/g, " ") || ""}!
                </Typography>
            </Box>
            <Box className={`${classes.divHomeBoxMedicalProfile} `}>
                <MedicalSection
                    title="Mis Notificaciones"
                    linkTo="/AllCommunications"
                    titleClass="titleMedicalCards"
                    linkClass="titleHomeMedicalProfileBox"
                >
                    {communicated?.communication && communicated?.communication.length > 0 ? (
                        communicated?.communication?.filter(item => item?.status === 1 && new Date(item.initialDate) <= new Date() && new Date(item.finalDate) >= new Date()).slice(0, 3)
                            .map((communication, index) => (
                                <CardCommunication
                                    key={index}
                                    communication={communication} position={index} />
                            ))
                    ) : (
                        <Box className={classes.boxHomeNotResult}>
                            <NotFound
                                customMsg={
                                    <Box className={classes.contentNotFound} >
                                        <Typography>No tienes comunicaciones</Typography>
                                    </Box>
                                }
                                wsItem={communicated?.communication}
                                fullItem={communicated?.communication}
                            />
                        </Box>
                    )}
                </MedicalSection>
                <MedicalSection
                    title="Mi Agenda"
                    linkTo="/CalendarMedical"
                    titleClass="titleAgenda"
                    linkClass="titleHomeMedicalProfileBoxAgenda"
                >
                    {!closestTurn ? (
                        modelAgendaMedicalReducer?.medicalAgenda?.agenda?.length === 0 ? (
                            <Box className={classes.boxHomeNotResult}>
                                <NotFound
                                    customMsg={
                                        <Box className={classes.contentNotFound}>
                                            <Typography>El médico no tiene agenda asociada</Typography>
                                        </Box>
                                    }
                                    wsItem={modelAgendaMedicalReducer?.medicalAgenda?.agenda}
                                    fullItem={modelAgendaMedicalReducer?.medicalAgenda?.agenda}
                                />
                            </Box>
                        ) : (
                            <CenteredCircularProgress />
                        )
                    ) : (
                        <HomeCardDetailPatient
                            key={closestTurn?.turnoNumero}
                            headerIcon={<HeaderCard day={format(new Date(closestTurn?.turnoFechHora), 'EEEE', { locale: es })} numberDay={format(new Date(closestTurn?.turnoFechHora), 'd', { locale: es })} month={format(new Date(closestTurn?.turnoFechHora), 'MM', { locale: es })} year={format(new Date(closestTurn?.turnoFechHora), 'yyyy', { locale: es })} />}
                            description={
                                <Box className={`${classes.boxHomeMedicalProfileAgenda}`}>
                                    <Typography className={`${classes.txtCardDescriptionHomeMedicalschedule}`}>
                                        <Box>
                                            <Box className={`${classes.boxHomeCards}`}>
                                                Horario  {format(new Date(closestTurn?.turnoFechHora), 'HH:mm')}
                                                {" a "}
                                                {format(new Date(lastTurnOfDay?.turnoFechHora), 'HH:mm')}
                                            </Box>
                                        </Box>
                                    </Typography>
                                    <Box className={classes.cartillaMedicalCenterSection}>
                                        <LocationCityIcon className={classes.LocationCityIconMedical} />
                                        <Typography className={`${classes.txtCardDescriptionHomeMedical}`}>
                                            {closestTurn?.centroMedicoDescripcion}
                                        </Typography>
                                    </Box>


                                    <Typography className={`${classes.txtCardDescriptionHomeMedicalDescription}`}>
                                        {closestTurn?.especialidadDescripcion}
                                    </Typography>

                                    <Typography className={`${classes.txtCardDescriptionHomeMedicineShiftsTotals}`}>
                                        Turnos totales: {totalTurns}
                                    </Typography>
                                    <Typography className={`${classes.txtCardDescriptionHomeMedicineShiftsTotals}`}>
                                        Próximos turnos: {assignedTurns}
                                    </Typography>
                                </Box>
                            }
                        />
                    )}
                </MedicalSection>
            </Box>
        </>
    );
};
export default MedicalProfile;

